import { useAppDispatch } from 'hooks/useAppDispatch';
import React from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { AgentService } from 'services/AgentService';
import { Button } from 'ui/redesign/Button';
import { Spinner } from 'ui/Spinner';

export const ResultForm = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const requestDoneHandler = (title: string) => {
    dispatch(
      modalActions.handleOpenModal({
        content: (
          <div className="flex w-full justify-center">
            <Button className="mt-6" onClick={closeModal}>
              ПРИНЯТЬ
            </Button>
          </div>
        ),
        options: {
          title,
        },
      })
    );
  };

  const closeModal = () => {
    dispatch(modalActions.closeModal());
  };

  // черновик для нового метода оплаты
  const { isFetching } = useQuery(
    ['getClientOrdersResults'],
    () => AgentService.getClientOrders(11, false, 999),
    {
      onSuccess: () => {
        requestDoneHandler(
          'Проверки пройдены успешно. Начался процесс выплат... Проверки пройдены успешно. Начался процесс выплат...'
        );
        queryClient.refetchQueries('getClientOrder');
      },
      onError: (data: any) => {
        requestDoneHandler(data.response?.data.detail ?? 'Произошла ошибка');
      },
    }
  );
  return <div className="flex w-full">{isFetching ? <Spinner /> : null}</div>;
};
